import { Button, IconFont, Select } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
`

export const FormItemWrapper = styled.div`
    margin-top: 8px;
`

export const Item = styled.div`
    width: 100%;
    padding: 0 0 12px 0;

    &:last-child {
        padding-bottom: 4px;
    }

    .mantine-Input-wrapper {
        margin-top: 12px;
    }
`

export const Text = styled.span<{ size?: number; color?: string }>`
    font-size: ${({ size }) => size ?? 14}px;
    color: ${({ color }) => color ?? 'var(--color-black)'};
    display: flex;
    align-items: center;
    gap: 6px;
`

export const Icon = styled(IconFont)`
    cursor: pointer;
    color: var(--color-gray-400);
`

export const TooltipContent = styled.div`
    line-height: 22px;
    vertical-align: middle;
`
